document.addEventListener("DOMContentLoaded", function() {
  const API_URL = "https://zxnpiek4i9.execute-api.ap-south-1.amazonaws.com/default/DHL_LAMBDA_FUNCTION";

  const form = document.getElementById("dhl-rate-form");
  if (!form) return;

  form.addEventListener("submit", function(e) {
    e.preventDefault();

    const destCountry = document.getElementById("dhl-country").value;
    const destPostal = document.getElementById("dhl-postal").value;

    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const payload = {
          rate: {
            origin: { country: "IN", postal_code: "410218", city: "Panvel" },
            destination: { country: destCountry, postal_code: destPostal, city: "Unknown" },
            items: cart.items.map(item => ({
              name: item.title,
              grams: item.grams,
              price: item.price / 100,
              quantity: item.quantity
            }))
          }
        };

        return fetch(API_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
      })
      .then(res => res.json())
      .then(data => {
        const output = document.getElementById("dhl-rates-output");
        if (data.rates && data.rates.length > 0) {
          output.innerHTML = "<ul>" +
            data.rates.map(r =>
              `<li><strong>${r.service_name}</strong>: ₹${(r.total_price/100).toFixed(2)} ${r.currency}</li>`
            ).join("") +
            "</ul>";
        } else {
          output.innerHTML = "<p>No DHL rates available</p>";
        }
      })
      .catch(err => {
        console.error("DHL Rate Fetch Error:", err);
        document.getElementById("dhl-rates-output").innerHTML = "<p>Error fetching DHL rates</p>";
      });
  });
});
